import { isDefined } from "@omni/utils/helper.utils";
import { cn } from "@omni/utils/styles";

import { AutocompleteItem } from "@/components/Search/SearchBar/AutocompleteItem/autocompleteItem.container";
import Highlight from "@/components/Search/SearchBar/Highlight/highlight.component";
import { BaseItemProps } from "@/components/Search/SearchBar/ResultsPanel/resultsPanel.templates";
import { QuerySuggestionsSourceType } from "@/components/Search/SearchBar/searchBar.types";

import { getRedirectUrlFromState } from "../helpers/redirect.helpers";

type AutocompleteSuggestionsProps = BaseItemProps<QuerySuggestionsSourceType>;

const QuerySuggestionsItem = ({
    item,
    autocompleteState,
    autocompleteActions
}: AutocompleteSuggestionsProps) => (
    <AutocompleteItem<QuerySuggestionsSourceType>
        query={item.query}
        className={cn("tw:flex tw:rounded-sm")}
        itemId={item.__autocomplete_id}
        autocompleteState={autocompleteState}
        autocompleteActions={autocompleteActions}
        getRedirectUrl={() =>
            isDefined(autocompleteState)
                ? getRedirectUrlFromState(autocompleteState)
                : undefined
        }
    >
        <div>
            <i className={cn("las la-search", "tw:pr-2")} />
        </div>
        <Highlight
            highlightMatch={item._highlightResult.query}
            reverseHighlight={true}
        />
    </AutocompleteItem>
);

export { QuerySuggestionsItem };
